import React from 'react'
import styles from './SuccessStory.module.css'
import SuccessStoryBox from './SuccessStoryBox'
import type { SuccessStoryItem } from './types'

const successStoryItems: SuccessStoryItem[] = [
    {
        href: 'https://food-stadium.com/special/34956/',
        src: '/pages/business/foodstadium/success-story-1.png',
        alt: '売上50億「うしごろ」の採用成功の鍵とFoodsLabo活用法！',
    },
    {
        href: 'https://food-stadium.com/special/37677/',
        src: '/pages/business/foodstadium/success-story-2.png',
        alt: '年約70名採用＆88％定着率の秘訣！人手不足ゼロへ',
    },
    {
        href: 'https://food-stadium.com/special/37840/',
        src: '/pages/business/foodstadium/success-story-3.png',
        alt: 'U35積極採用中！若手に魅力が伝わる「フーズラボ」活用術',
    },
    {
        href: '#',
        src: '/pages/business/foodstadium/success-story-4.png',
        alt: 'coming soon',
        external: false,
    },
]

export default function SuccessStory() {
    return (
        <section id='success-story'>
            <h1 className={styles.successStoryPc}>
                <img
                    src='/pages/business/foodstadium/success-story-pc.svg'
                    alt='特別コラボ 成功事例公開中！'
                />
            </h1>
            <h1 className={styles.successStorySp}>
                <img
                    src='/pages/business/foodstadium/success-story-sp.png'
                    alt='特別コラボ 成功事例公開中！'
                />
            </h1>
            <div className={styles.successStoryMain}>
                <SuccessStoryBox items={successStoryItems} />
                <a
                    className={styles.articleList}
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://food-stadium.com/?s=cuolega&x=0&y=0'
                >
                    記事一覧へ
                </a>
            </div>
        </section>
    )
}
